import Plugin from "./Plugin.js";

class MultiFilter extends Plugin {
    init() {
        let options = this.$table.data('config');
        this.datatable.api().columns().every((key, row) => {
            if (options.columns[key].searchable !== true) {
                return;
            }

            let header = this.datatable.api().column(key).header();
            let $header = $(header);
            let searchTerm = this.datatable.api().column(key).search();

            if (searchTerm.length > 0) {
                $header.data('search', searchTerm);
            }

            this._generateInput($header, key, options);

            $('input', header).on('click', (event) => {
                event.preventDefault();
                event.stopPropagation();
            });
            $('input', header).on('keydown', this._onSearch.bind(this, key))
        });
    }

    _onSearch(key, event) {
        if (event.keyCode === 13) {
            event.cancelBubble = true;
            event.preventDefault();
            event.stopPropagation();
            return;
        }
        let input = event.currentTarget;
        this.timeout ? clearTimeout(this.timeout) : null;
        this.timeout = setTimeout(() => {
            if (input.value == '') {
                $(input).removeClass('bg-warning');
            } else {
                $(input).addClass('bg-warning');
            }
            this.datatable.api().column(key).search(input.value).draw();
        }, 500)
    }

    _generateInput($header, key, options) {
        let title = $header.text();
        let classes = 'form-control pull-left datatable-form-control';
        if (options.columns[key].headingClasses !== undefined) {
            classes += ' ' + options.columns[key].headingClasses;
        }

        let $input = $('<input style="width: calc( 100% );" class="' + classes + '" type="text" title="' + title + '" placeholder="' + title + '" />');
        $input.val($header.data('search'));
        if ($header.data('search') != undefined) {
            $input.addClass('bg-warning');
        } else {
            $input.removeClass('bg-warning');
        }

        let $title = $header.find('.dt-column-title');

        $title.html(`<span class="column-title">${title}</span>`);
        $title.append($input);
    }
}

export default MultiFilter;
